module.exports = __webpack_public_path__ + "static/media/thirty_percent.ffb6a6f7.png";